<template>
    <div class="main__wrapper main__container container">
        <h1 class="view_title mb-5 md:mb-17">
            Auto Comparador
        </h1>
        <div class="comparator__table box box--white box--shadow-lg flex mb-8 lg:mb-20">

            <div v-if="comparativeView.numberProducts && comparativeView.numberProducts > 1" class="comparator__col hidden lg:flex">
                <div class="comparator__col__head">
                    <div class="px-8 py-10">
                        <span class="tx-18 tx-blue-1 weight-500">
                            Features
                        </span>
                    </div>
                </div>
                <div class="comparator__col__body">
                    <div class="comparator__heading">
                        <span>
                            Usuario verificado
                        </span>
                    </div>
                    <div class="comparator__heading">
                        <span>
                            Precio
                        </span>
                    </div>
                    <template v-for="(spec) in getSpecsTitles()">
                        <div class="comparator__heading" :key="'_specs_title_' + spec">
                            <span>{{ spec }}</span>
                        </div>
                    </template>

                </div>
                <div class="comparator__col__footer">
                    <div class="comparator__heading">
                        <a class="tx-12 xl:tx-14 weight-700 tx-blue-1 flex align-items-center underline" @click="showSocial($event)">
                            Compartir esta comparación
                            <img class="ml-2" width="16px" src="/assets/images/helpers/icon-share.svg" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <template v-if="comparativeView.numberProducts && comparativeView.numberProducts > 1">
                <div v-for="(number) in comparativeView.numberProducts" :key="number" class="comparator__col flex">
                    <template v-if="!!currentComparative(number)">
                        <div class="comparator__col__head">
                            <div class="data__car px-2 md:px-4 lg:px-8 py-6">
                                <div v-if="!comparativesProps" style="position: relative;float: right;" class="cursor-pointer" @click="removeComparative( currentComparative(number).id )">x</div>
                                <p class="tx-10 md:tx-14 tx-grey-1 flex align-items-center">
                                    <img class="mr-2" width="11px" src="/assets/images/helpers/icon-pimmap.svg" alt="">
                                    {{ currentComparative(number).city.title + ', ' + currentComparative(number).state.name }}
                                </p>
                                <div class="render__img__car bg-center bg-cover bg-no-repeat w-full h-16 md:h-25 lg:h-30 xl:h-40 rounded-4 mb-4" :style="'background-image: url(' + getCoverImage( currentComparative(number) ) + ');'">
                                </div>
                                <div class="flex flex-column md:flex-row md:justify-content-between align-items-start md:align-items-center md:mb-6">
                                    <div class="rating mb-2 md:mb-0">
                                        <div class="stars__rating">
                                            <div class="stars_outer">
                                                <div class="stars_inner" :style="'width: ' + averageScore( currentComparative(number).average_score ) + '%;'"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hidden md:block">
                                        <span class="badge badge--agency">
                                            {{  currentComparative(number).user_type }}
                                        </span>
                                    </div>
                                </div>
                                <div class="overflow-hidden tx-12 md:tx-18 tx-blue-1 underline weight-500" style="height: 46px;">
                                    <a :href="`/anuncio/${currentComparative(number).id}`">{{  getTitle(currentComparative(number)) }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="comparator__col__body tx-12 md:tx-16">
                            <div class="comparator__cell">
                                <span  v-if="currentComparative(number) && currentComparative(number).user && currentComparative(number).user.documents && currentComparative(number).user.documents.status == 'validated'">
                                    <img width="35px" src="/assets/images/layout/turn-verificado.svg" alt="">
                                </span>
                                <span v-else> - </span>
                            </div>
                            <div class="comparator__cell bg-lightorange">
                                <label class="comparator__label">
                                    Precio:
                                </label>
                                <span class="tx-12 md:tx-16 lg:tx-22 tx-orange-1">
                                    ${{ formatPrice(currentComparative(number).price) }} MXN
                                </span>
                            </div>

                            <div v-for="(spec) in getSpecsTitles()" :key="'_spec_value' + number + spec" class="comparator__cell">
                                <label class="comparator__label"> {{ spec }} </label>
                                <span> {{ getSpecsValues(currentComparative(number), spec) }} </span>
                            </div>
                        </div>
                        <div class="comparator__col__footer">
                            <div class="comparator__cell">
                                <whatsapp-button-component v-if="currentComparative(number).cellphone_country_code && currentComparative(number).cellphone" :user_id="user_id" :product_id="currentComparative(number).id" :cellphone="currentComparative(number).cellphone_country_code + currentComparative(number).cellphone" message=""></whatsapp-button-component>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <div class="tx-center tx-blue-1 py-20 mx-a" v-else>
                Comparativa vacía
            </div>

        </div>

        <div class="mb-10 lg:hidden">
            <div class="tx-14 weight-700 tx-blue-1 underline" @click="showSocial($event)">
                Compartir esta comparación
                <img class="ml-2" width="16px" src="/assets/images/helpers/icon-share.svg" alt="">
            </div>
        </div>

        <social-share-compare-component
            v-if="socialShare"
            @close="socialShare = false"
            :product_one="comparativeView.product_one"
            :product_two="comparativeView.product_two"
            :product_three="comparativeView.product_three"
            :share_link="comparativeView.shareLink"
        ></social-share-compare-component>

    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {

        props: ['comparativesProps'],

        data() {
            return {
                user_id: null,
                comparative: {},
                socialShare: false,
                loadComparatives: false,
                currentSpecs: [],

                formData: null,
                err: {}
            }
        },

        created() {
            let vm = this;

            var interval = setInterval( function(){
                if ( vm.loadComparatives ) {
                    vm.verifyProducts();
                    clearInterval(interval);
                }
            }, 1000);
        },

        computed: {
            ...mapState(['user']),
            ...mapState('comparative', ['comparatives']),

            comparativeView: {
                get: function() {
                    return this.comparative;
                }, set: function(value){
                    this.comparative = value;
                }
            }

        },

        watch: {
            user(state) {
                let vm = this;
                if ( state.id !== undefined ) {
                    vm.user_id = state.id;
                }
            },
            comparatives(state) {
                let vm = this;
                if ( vm.comparativesProps ) {
                    vm.comparativeView = vm.comparativesProps;
                    vm.loadComparatives = true;
                }else if ( state.id !== undefined && !this.comparativesProps ) {
                    vm.comparativeView = state;
                    vm.loadComparatives = true;
                }
            },
        },

        methods: {

            getSpecsTitles() {
                let vm = this;
                if (vm.currentSpecs.length == 0) {

                    for (let product_number = 1; product_number <= 3; product_number++) {

                        if (!!vm.currentComparative(product_number) && !!vm.currentComparative(product_number).specs) {
                            vm.currentComparative(product_number).specs = JSON.parse(vm.currentComparative(product_number).specs.specs);

                            _.map( vm.currentComparative(product_number).specs, function(spec) {
                                if ( !vm.currentSpecs.includes(spec.name.trim()) ) {
                                    vm.currentSpecs.push(spec.name.trim());
                                }
                            })

                        }

                    }

                }
                return vm.currentSpecs;
            },

            getSpecsValues(product, specs) {
                let vm = this;
                let value = '-';

                if (!!product.specs) {
                    let searchSpec = _.filter( product.specs, function(spec) {
                        return spec.name == specs;
                    });
                    if (searchSpec.length > 0) {
                        value = searchSpec[0].value;
                    }
                }
                return value;
            },

            showSocial(event) {
                event.preventDefault();
                this.socialShare = true;
            },

            formatPrice(value) {
                let val = (value/1).toFixed(2)
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            averageScore(value) {
                return ( value * 2 ) * 10;
            },

            getCoverImage(product) {
                return product.card_cover ?
                    product.card_cover.image :
                    product.gallery_first.image;
            },

            getTitle(product) {
                return product.brand.title + ' ' + product.model.title + ' ' + product.version + ' ' + product.year;
            },

            removeProduct(value) {
                let vm = this;

                    vm.resetForms();
                    vm.formData.append('product_id', value);
                    vm.$swal({
                        icon: "info",
                        title: "Confirmar operación",
                        text: "¿Estas seguro de remover el producto de la comparación?",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    }).then((result) => {
                        if (result) {
                            let {data} = axios.post('/client/comparatives/update/' + vm.comparatives.id, vm.formData)
                            .then(response => {
                                vm.$store.dispatch('comparative/getComparatives');

                            }).catch(error => {
                                vm.showErrors(error);
                            });
                            vm.$swal({
                                icon: 'success',
                                title: 'Producto removido',
                                text: 'Se removió de la comparación el producto',
                            });
                        }
                    });
            },

            currentComparative(key) {
                let vm = this;
                switch(key) {
                    case 1:
                        return vm.comparativeView.product_one;
                        break;
                    case 2:
                        return vm.comparativeView.product_two;
                        break;
                    case 3:
                        return vm.comparativeView.product_three;
                        break;
                }
            },

            resetForms() {
                let vm = this;
                vm.formData = new FormData();
                vm.err = [];
            },

            showErrors(error = null) {
                let vm = this;
                if ( error ) {
                    vm.err = error.response.data;
                }
                vm.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
                });
            },

            removeComparative(value) {
                let vm = this;

                vm.resetForms();
                vm.formData.append('product_id', value);
                vm.$swal({
                    icon: "info",
                    title: "Confirmar operación",
                    text: "¿Estas seguro de remover el producto de la comparación?",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    confirmButtonText: 'Aceptar'
                }).then((result) => {
                    if (result) {
                        let {data} = axios.post('/client/comparatives/update/' + vm.comparatives.id, vm.formData)
                        .then(response => {
                            vm.$store.dispatch('comparative/getComparatives');
                        }).catch(error => {
                            vm.showErrors(error);
                        });
                        vm.$swal({
                            icon: 'success',
                            title: 'Producto removido',
                            text: 'Se removió de la comparación el producto',
                        });
                    }
                });
            },

            verifyProducts() {
                let vm = this;
                var error = false;

                let error_content = [];
                error_content['title']  = 'No tienes vehículos para comparar';
                error_content['text']   = 'Primero debes de seleccionar algunos de los vehículos dando click en Comparar.';

                error = vm.comparativeView.numberProducts === undefined || vm.comparativeView.numberProducts < 2;

                if ( !error ) {
                    let products = [
                        !!vm.currentComparative(1),
                        !!vm.currentComparative(2),
                        !!vm.currentComparative(3)
                    ];

                    error = products.filter(function (el) { return !!el; }).length <= 1;
                    error_content['title'] = 'Parece que esta comparación ya no está disponible';
                    error_content['text'] = 'Uno o más de los vehículos seleccionados ya no están disponibles';
                }

                if (error) {
                    vm.$swal({
                        icon: 'error',
                        title: error_content['title'],
                        text: error_content['text'],
                    });
                }
            }
        }
    }
</script>
